var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomTrustpilotStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9995 20.533L20.0828 18.9914L22.6245 26.8247L13.9995 20.533ZM27.9995 10.408H17.2912L13.9995 0.324707L10.7078 10.408H-0.000488281L8.66618 16.658L5.37451 26.7414L14.0412 20.4914L19.3745 16.658L27.9995 10.408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomTrustpilotStar);
export default __webpack_public_path__ + "static/media/bottomTrustpilotStar.7333f547eba04d03ab1dfd1b66f0b206.svg";
export { ForwardRef as ReactComponent };